
export const MuiCard = {
    styleOverrides: {
        root: {
            boxShadow: "0px 21px 12px -11px rgba(108, 121, 134, 0.1)"
        },
    },
    defaultProps: {
    },
}